<form [formGroup]="formGroup" class="adjustment-wrapper">
  <div class="adjustment-form">
    <mat-checkbox formControlName="checked" color="primary">
      <mat-label> DIAMOND Balance Adjustment </mat-label>
    </mat-checkbox>
  </div>
  @if (formGroup.get('checked').value) {
    <div class="adjustment-entries-wrapper">
      <div class="adjustment-entry">
        <div>Diamond balance:</div>
        <div class="diamonds-holder">
          <app-diamonds [value]="currentValue"></app-diamonds>
          <div class="worth">
            <span>Worth </span>
            <app-form-field-money
              class="inline"
              [fieldConfig]="currentWorthConfig"
              [editMode]="false"
              [data]="this.currentWorth">
            </app-form-field-money>
          </div>
        </div>
      </div>
      <div class="adjustment-entry">
        <div>Adjustment {{ operation }}:</div>
        <div>
          <div class="adjustment-input">
            <mat-button-toggle-group appearance="legacy" formControlName="adjustmentType">
              <mat-button-toggle value="CREDIT"><i class="fas fa-plus"></i></mat-button-toggle>
              <mat-button-toggle value="DEBIT"><i class="fas fa-minus"></i></mat-button-toggle>
            </mat-button-toggle-group>
            <div class="diamond-balance">
              <i class="fas fa-gem"></i>
              <mat-form-field>
                <input matInput formControlName="delta" class="adjustment-input" />
              </mat-form-field>
            </div>
          </div>
          <div class="worth">
            <span>Worth </span>
            <app-form-field-money
              class="inline"
              [fieldConfig]="deltaWorthConfig"
              [editMode]="false"
              [data]="deltaWorth">
            </app-form-field-money>
          </div>
        </div>
      </div>
      <mat-divider class="adjustment-divider"></mat-divider>
      <div class="adjustment-entry adjustment-summary {{ summaryClass }}">
        <div>
          <i class="{{ summaryIcon }}"></i>
          <span>Diamond new balance</span>
        </div>
        <div class="info-container">
          <app-diamonds [value]="postChangesValue"></app-diamonds>
          <div class="worth">
            <span>Worth </span>
            <app-form-field-money
              class="inline"
              [editMode]="false"
              [data]="postChangesWorth"
              [fieldConfig]="postChangesWorthConfig">
            </app-form-field-money>
          </div>
        </div>
      </div>
    </div>
  }
</form>
